(function () {
  const MOBILE_BREAKPOINT = 585;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function initCollectionsNav() {
    const nav = document.querySelector('.collections-home');
    if (!nav) return;

    const links = Array.from(nav.querySelectorAll('a'));
    if (links.length === 0) return;

    const targets = links.map((link) => {
      const id = link.getAttribute('href')?.slice(1);
      return id ? document.getElementById(id) : null;
    });

    function applyMobileState() {
      if (!isMobile()) {
        for (const target of targets) {
          if (target) target.style.display = '';
        }
        return;
      }

      const selectedIndex = links.findIndex((link) => link.classList.contains('selected'));
      const activeIndex = selectedIndex !== -1 ? selectedIndex : 0;

      if (selectedIndex === -1) {
        links[0]?.classList.add('selected');
      }

      targets.forEach((target, index) => {
        if (!target) return;
        //target.style.display = index === activeIndex ? '' : 'none';
      });
    }

    function selectItem(index) {
      links.forEach((link, i) => {
        link.classList.toggle('selected', i === index);
      });

      if (isMobile()) {
        targets.forEach((target, i) => {
          if (!target) return;
          //target.style.display = i === index ? '' : 'none';
        });
      }
    }

    links.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        //if (isMobile()) e.preventDefault();
        selectItem(index);
      });
    });

    applyMobileState();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(applyMobileState, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionsNav);
  } else {
    initCollectionsNav();
  }
})();
